const saveExpenses = (expenses, onError) => {
  try {
    const request = openDB();
    
    request.onsuccess = (event) => {
      const db = event.target.result;
      
      try {
        const transaction = db.transaction("expenses", "readwrite");
        const store = transaction.objectStore("expenses");
        
        expenses.forEach((expense) => {
          store.add(expense);
        });
        
      } catch (error) {
        onError(error.message);
      }
    };
  } catch (error) {
    onError(error.message);
  }
};

const getSavedExpenses = async (onSuccess, onError) => {
  try {
    const databases = await window.indexedDB.databases();
    if (!databases.some(db => db.name === 'xpens')) {
      return onSuccess([]);
    }

    const request = openDB();

    request.onsuccess = (event) => {
      const db = event.target.result;

      try {
        const transaction = db.transaction("expenses", "readonly");
        const store = transaction.objectStore("expenses");

        const getAllRequest = store.getAll();

        getAllRequest.onsuccess = () => {
          onSuccess(getAllRequest.result);
        };

      } catch (error) {
        onError(error.message);
      }
    };
  } catch (error) {
    onError(error.message);
  }
};

const clearExpenses = () => {
  try {
    const request = openDB();

    request.onsuccess = (event) => {
      const db = event.target.result;

      try {
        db.transaction("expenses", "readwrite")
          .objectStore("expenses")
          .clear();
          
      } catch (error) {}
    };
  } catch (error) {}
};

const openDB = () => {
  const request = window.indexedDB.open('xpens', 1);
  
  request.onupgradeneeded = (event) => {
    const db = event.target.result;
    db.createObjectStore("expenses", { autoIncrement: true });
  };

  return request;
};

export { saveExpenses, getSavedExpenses, clearExpenses };
